import type { VoivodeshipWithoutPolishCharacters } from "apps/visits/core/types/voivodeship";

type VoivodeshipLink = `/pp/${VoivodeshipWithoutPolishCharacters}/zakup-badania`;

export const generateVoivodeshipLink = (name: VoivodeshipWithoutPolishCharacters): VoivodeshipLink => {
  return `/pp/${name}/zakup-badania`;
};
